import React from 'react';
import {Image} from 'antd-mobile';
import {useTranslation} from 'react-i18next';
import HomeBottomCard from '@/components/business/home-bottom-card/home-bottom-card';
import instagramIcon from '@assets/imgs/home/social1.png';
import facebookIcon from '@assets/imgs/login/facebook.webp';
import youtubeIcon from '@assets/imgs/home/social4.webp';
import social3 from '@assets/imgs/home/social3.webp';

const HomeSocial = () => {
  const {t} = useTranslation();

  // 添加社交媒体链接
  const list = [
    {
      label: 'telegram',
      image: social3,
      link: 'https://t.me/spinbaji',
    },
    {
      label: 'instagram',
      image: instagramIcon,
      link: 'https://www.instagram.com/spinbaji',
    },
    {
      label: 'facebook',
      image: facebookIcon,
      link: 'https://www.facebook.com/profile.php?id=61576285201656',
    },
    {
      label: 'youtube',
      image: youtubeIcon,
      link: 'https://www.youtube.com/@spinbajii',
    },
  ];

  return (
    <HomeBottomCard
      title={t('home.label.social')}
      gap={'gap-3'}
      imgs={list as any}
      renderItem={(item: any) => (
        <div
          key={item.label}
          className="h-[1.75rem] cursor-pointer"
          onClick={() => (window.location.href = item.link)}>
          <Image src={item.image} height={'1.75rem'} width={'1.75rem'} />
        </div>
      )}
    />
  );
};

export default HomeSocial;
